(() => {
  if (window.__ttRichTextReady) return;
  window.__ttRichTextReady = true;
  const running = new Map();

  function init(root = document) {
    const sections = [...root.querySelectorAll('.rich-text-section')];
    if (root.matches?.('.rich-text-section')) sections.unshift(root);
    sections.forEach(section => {
      const element = section.querySelector('.rich-text__subheading-animation');
      // Plain rich-text sections intentionally have no animated subheading.
      if (!element || !element.dataset.text || running.has(section) || element.classList.contains('js-text-init')) return;
      const characters = Array.from(element.dataset.text);
      const state = { observer: null, timer: null, index: 0 };
      running.set(section, state);
      section.classList.add('js-init');

      function print() {
        if (!element.isConnected) return;
        element.append(document.createTextNode(characters[state.index++]));
        if (state.index < characters.length) state.timer = setTimeout(print, 100);
      }
      function start() {
        if (element.classList.contains('js-text-init')) return;
        element.classList.add('js-text-init');
        state.observer?.disconnect();
        if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
          element.append(document.createTextNode(characters.join('')));
          state.index = characters.length;
        } else print();
      }
      if (typeof IntersectionObserver === 'function') {
        state.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) start();
        });
        state.observer.observe(element);
      } else start();
    });
  }

  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [section, state] of running) {
      if (section === event.target || event.target.contains(section)) {
        clearTimeout(state.timer);
        state.observer?.disconnect();
        running.delete(section);
      }
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
